<template>
  <textarea v-model="input" @keydown="keydown" class="resize-none" />
</template>

<script>
import { useTextareaAutosize } from "@vueuse/core";
export default {
  props: ["value"],
  data() {
    return {
      input: this.value,
    };
  },

  methods: {
    keydown(e) {
      const keyCode = e.keyCode || e.which;

      if (keyCode === 9) {
        e.preventDefault();

        const TAB_SIZE = 2;
        e.target.value += "　".replace(TAB_SIZE);
      }
    },
    resize() {
      useTextareaAutosize({
        element: this.$el,
        input: this.input,
        // styleTarget: this.$el,
        onResize: () => {
          // calulate min height by attribute rows
          this.$el.style.minHeight = `${this.$el.rows * 1.5}rem`;
        },
        watch: () => {
          this.$emit("input", this.input);
          
        },
      });
    },
  },
  watch: {
    value(val) {
      this.input = val;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.resize();
    });
  },
  
};
</script>
